import { render, staticRenderFns } from "./InformationSection.vue?vue&type=template&id=cb05d5e8&scoped=true&"
import script from "./InformationSection.vue?vue&type=script&lang=ts&"
export * from "./InformationSection.vue?vue&type=script&lang=ts&"
import style0 from "./InformationSection.vue?vue&type=style&index=0&id=cb05d5e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb05d5e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
